// removed by extract-text-webpack-plugin
module.exports = {"mainWrapper":"mainWrapper__3Lplz"};


//////////////////
// WEBPACK FOOTER
// ./components/paginationPanel/style.scss
// module id = qnaA
// module chunks = 0